// Maps human color names (used in product variants) to a display swatch color.
// Falls back to null for non-color names like sizes/scents.

const COLOR_MAP: Record<string, string> = {
  // neutrals
  cream: "#efe6d2",
  ivory: "#f5ecd9",
  "warm sand": "#d9c3a0",
  sand: "#dac8a8",
  beige: "#d8c4a4",
  natural: "#e7d8be",
  oat: "#dccfb6",
  linen: "#e7dcc8",
  white: "#fbfaf6",
  "off white": "#f3eee2",
  "foggy grey": "#b4b1a6",
  grey: "#9c9a93",
  gray: "#9c9a93",
  charcoal: "#3d3a36",
  black: "#1a1816",
  // greens
  moss: "#7b8a5c",
  "moss green": "#7b8a5c",
  sage: "#a3b08c",
  olive: "#7c7a4a",
  forest: "#3f5c3c",
  // browns / warm
  terracotta: "#c1684a",
  rust: "#a14a2e",
  clay: "#b07355",
  cedar: "#8a5a3b",
  caramel: "#a86a3c",
  mahogany: "#5b3422",
  walnut: "#4a3023",
  // reds / pinks
  blush: "#e6c5b9",
  rose: "#d99a98",
  burgundy: "#6f2031",
  brick: "#a14438",
  cherry: "#a83245",
  // yellows
  ochre: "#c9974b",
  mustard: "#cda03b",
  honey: "#d8a554",
  // blues (used sparingly)
  navy: "#1f2c44",
  slate: "#5d6a76",
  // purples
  lavender: "#b7a3c4",
  plum: "#5a3a52",
  // others
  tobacco: "#7a5236",
  "tobacco & vanilla": "#a07a52",
  vanilla: "#e8d6b4",
  // portuguese (pt-BR)
  terracota: "#c1684a",
  musgo: "#7b8a5c",
  areia: "#dac8a8",
  petróleo: "#2f4a44",
  argila: "#b07355",
  palha: "#dccfb6",
  caramelo: "#a86a3c",
};

export function getSwatchColor(value: string): string | null {
  if (!value) return null;
  const key = value.trim().toLowerCase();
  if (COLOR_MAP[key]) return COLOR_MAP[key];
  // try partial match (e.g. "Cedar Smoke" → "cedar")
  for (const k of Object.keys(COLOR_MAP)) {
    if (key.includes(k)) return COLOR_MAP[k];
  }
  return null;
}

// Heuristic: is this variant a color variant (so we can show swatches)?
export function isColorVariant(name: string): boolean {
  const n = name.toLowerCase().trim();
  return (
    n === "cor" ||
    n.includes("color") ||
    n.includes("colour") ||
    n.includes("shade") ||
    n.includes("finish")
  );
}